<template>
  <div>
    <!-- SECCIÓN 1: LLUVIA DE SOBRES -->
    <section ref="raiz" class="lluvia-sobres">
      <div class="contenido">
        <h2 ref="tituloRef" class="titulo">
          <span class="serif">Con</span><br />
          <span class="script">Cariño</span>
        </h2>

        <p ref="textoRef" class="texto">
          Tu presencia es el regalo más valioso para mí. ✨  
          Pero si deseas tener un detalle, lo recibiré con mucho aprecio  
          y profunda gratitud, sin ser en absoluto una obligación.
        </p>

        <img
          ref="sobreRef"
          :src="sobrePng"
          alt="Sobre"
          class="icono-sobre"
        />

        <p ref="graciasRef" class="gracias">¡GRACIAS!</p>
      </div>

      <div ref="lluviaIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaDer" class="lluvia lluvia-der"></div>
    </section>

    <!-- SECCIÓN 2: BIENVENIDA A LOS NIÑOS -->
    <section ref="raizNinos" class="lluvia-sobres">
      <div class="contenido">
        <h2 ref="tituloNinosRef" class="titulo">
          <span class="serif">¡ Sí Niños!</span>
        </h2>

        <p ref="textoNinosRef" class="texto">
          Con alegría les damos la bienvenida también a sus pequeños.  
          Para que la fiesta sea un éxito, les pedimos mantenerlos siempre cerca  
          de ustedes durante la presentación.
        </p>
      </div>

      <div ref="lluviaNinosIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaNinosDer" class="lluvia lluvia-der"></div>
    </section>

    <!-- SECCIÓN 3: AVISO IMPORTANTE DE BEBIDAS -->
    <section ref="raizAviso" class="lluvia-sobres seccion-aviso">
      <div class="contenido">
        <h2 ref="tituloAvisoRef" class="titulo">
          <span class="serif">¡Aviso Importante!</span>
        </h2>

        <p ref="textoAvisoRef" class="texto texto-aviso">
       No estará permitido el acceso con bebidas alcohólicas. ¡Gracias por su comprensión para hacer de este día un recuerdo inolvidable! 
        </p>
      </div>

      <div ref="lluviaAvisoIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaAvisoDer" class="lluvia lluvia-der"></div>

      <div class="rasgado rasgado-inferior"></div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {
    const raiz = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const graciasRef = ref(null)
    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)

    const raizNinos = ref(null)
    const tituloNinosRef = ref(null)
    const textoNinosRef = ref(null)
    const lluviaNinosIzq = ref(null)
    const lluviaNinosDer = ref(null)

    const raizAviso = ref(null)
    const tituloAvisoRef = ref(null)
    const textoAvisoRef = ref(null)
    const lluviaAvisoIzq = ref(null)
    const lluviaAvisoDer = ref(null)

    let stInstance = null
    let stInstanceNinos = null
    let stInstanceAviso = null

    const crearLluvia = (contenedorEl, lado, cantidad) => {
      if (!contenedorEl) return
      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.className = 'sobre-lluvia'
        contenedorEl.appendChild(el)

        gsap.fromTo(
          el,
          { xPercent: lado === 'der' ? 110 : -10, yPercent: -10, opacity: 0 },
          {
            xPercent: lado === 'der' ? -20 : 120,
            yPercent: 140,
            opacity: 0.9,
            duration: 2.2,
            ease: 'power2.out',
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      stInstance = ScrollTrigger.create({
        trigger: raiz.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          crearLluvia(lluviaDer.value, 'der', 10)
          crearLluvia(lluviaIzq.value, 'izq', 10)
        }
      })

      stInstanceNinos = ScrollTrigger.create({
        trigger: raizNinos.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          crearLluvia(lluviaNinosDer.value, 'der', 10)
          crearLluvia(lluviaNinosIzq.value, 'izq', 10)
        }
      })

      stInstanceAviso = ScrollTrigger.create({
        trigger: raizAviso.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          crearLluvia(lluviaAvisoDer.value, 'der', 8)
          crearLluvia(lluviaAvisoIzq.value, 'izq', 8)
        }
      })
    })

    onUnmounted(() => {
      stInstance?.kill()
      stInstanceNinos?.kill()
      stInstanceAviso?.kill()
    })

    return {
      raiz,
      tituloRef,
      textoRef,
      sobreRef,
      graciasRef,
      lluviaIzq,
      lluviaDer,
      raizNinos,
      tituloNinosRef,
      textoNinosRef,
      lluviaNinosIzq,
      lluviaNinosDer,
      raizAviso,
      tituloAvisoRef,
      textoAvisoRef,
      lluviaAvisoIzq,
      lluviaAvisoDer,
      sobrePng
    }
  }
}
</script>

<style scoped>
/* CONTENEDOR */
.lluvia-sobres {
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background: #a4bcac;
  overflow: hidden;
}

/* Sección específica de aviso */
.seccion-aviso {
  padding-bottom: 72px;
}

/* CONTENIDO */
.contenido {
  position: relative;
  z-index: 2;
}

/* TITULO */
.titulo {
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}

.titulo .serif {
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
}

.titulo .script {
  font-family: 'nombre', cursive;
  font-size: 44px;
  opacity: .95;
}

/* TEXTO */
.texto {
  font-family: 'quote', serif;
  font-size: 16px;
  line-height: 1.5;
  color: #fff;
  max-width: 420px;
  margin: 12px auto 18px;
}

/* Estilo para suavizar aviso */
.texto-aviso {
  font-size: 16.5px;
  letter-spacing: 0.01em;
  opacity: 0.95;
}

/* SOBRE CENTRAL */
.icono-sobre {
  width: 128px;
  max-width: 28vw;
  margin: 18px auto 10px;
  display: block;
  filter: drop-shadow(0 8px 14px rgba(0,0,0,.15));
}

/* GRACIAS */
.gracias {
  font-family: 'padres', serif;
  font-size: 24px;
  letter-spacing: .08em;
  color: #fff;
  font-weight: 800;
}

/* LLUVIA */
.lluvia {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

.sobre-lluvia {
  position: absolute;
  width: 28px;
  top: -10%;
  opacity: .9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.1));
}

/* Separador decorativo inferior */
.rasgado-inferior {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 24px;
  background-size: cover;
  z-index: 3;
}
</style>